module.exports = __webpack_public_path__ + "assets/img/footer_logo_10.923d95ae.png";